<div class="catalog">
  <div class="catalog__header">
    <app-custom-dropdown
      [options]="sortingOptions"
      [placeholder]="sortingDropdownPlaceholder"
      [showSelectedOptionAndPlaceholder]="true"
      (valueSelected)="onSortingChange($event)"
      *ngIf="!isPageLoading"
      >     
    </app-custom-dropdown>
    <app-skeleton *ngIf="isPageLoading" [width]="180" [height]="36"/>

    <h2 *ngIf="!isLoading" class="catalog__header-text">{{ resultText }} {{ totalSearchResultsCount }} </h2> 
    <h2 *ngIf="isLoading" class="catalog__header-text"><app-skeleton [type]="'text'" [symbolsCount]="12"/></h2> 
  </div>
  <div class="search-catalog__list">
    <ng-container *ngIf="!isLoading && cardLayoutData">
      <app-career-lobby-position-item
        *ngFor="let card of cards"
        [cardData]="card"
        [layoutData]="cardLayoutData"
        ></app-career-lobby-position-item>
    </ng-container>
    <ng-container *ngIf="isLoading || isPageLoading">
      <div class="service-item skeleton" *ngFor="let _ of [].constructor(pageSize ? pageSize : 9)">
        <app-skeleton [height]="320"/>
      </div>
    </ng-container>
    <div *ngIf="!isLoading && !totalPagesCount.length" class="catalog-empty-result">
      <div class="catalog-empty-result__title">
        {{noResultsTitle}}
      </div>
      <div class="catalog-empty-result__text" [innerHTML]="noResultsText"></div>
      <button class="catalog-empty-result__clear-btn link" (click)="clearAll()">
        <div>{{clearAllText}}</div>
      </button>
      <div class="catalog-empty-result__image">
        <img [src]="noResultsImage" width="202" height="283" />
      </div>
    </div>
  </div>
 
  <div class="catalog__footer" *ngIf="!isLoading">
    <app-paginator [totalResults]="totalSearchResultsCount!" [currentPage]="currentPage!" [pageSize]="pageSize!" (pageChanged)="goToPage($event)"  [paginatorContainerClass]="paginatorContainerCssClass"  [activeLiClass]="'active'"
    [activeLinkClass]="'active'" [liClass]="'pagination__link'" [linkClass]="'pagination__link_a'" [disabledLiClass]="''" [rangeSize]="rangeSize"></app-paginator>
  </div>
 </div>
